module.exports = __webpack_public_path__ + "static/insta7-c3a2b8b7269c8818f6bdbefb1578f857.png";